// store/modules/companies.js
import axios from 'axios';

const state = {
  companysData: [],
  companysTrainingsData: [],
  companysTrainingsPublicData:[]
};

const mutations = {
  SET_COMPANYS_DATA(state, data) {
    state.companysData = data;
  },
  SET_COMPANYS_TRAININGS_DATA(state, data) {
    state.companysTrainingsData = data;
  },
  SET_COMPANYS_TRAININGS_PUBLIC_DATA(state, data) {
    state.companysTrainingsPublicData = data;
  },
};

const actions = {
    async fetchCompanysData({ commit }, searchQuery) {
      try {
        // Include the search query in the API call
        const response = await axios.get('ministries/companies_search', {
          params: {
           ...searchQuery  // Use an empty string if searchQuery is null
          },
        });

        commit('SET_COMPANYS_DATA', response.data.data);
      } catch (error) {
        console.error('Error fetching companiesData:', error);
      }
    },


  async fetchCompanysTrainingsData({ commit }) {
    try {
      const response = await axios.get('ministries/training_companies');
      commit('SET_COMPANYS_TRAININGS_DATA', response.data.data);
    } catch (error) {
      console.error('Error fetching companiesTrainingsData:', error);
    }
  },
  async fetchCompanysTrainingsPublicData({ commit }) {
    try {
      const response = await axios.get('training_companies_list');
      commit('SET_COMPANYS_TRAININGS_PUBLIC_DATA', response.data.data);
    } catch (error) {
      console.error('Error fetching companiesTrainingsData:', error);
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
